import { Link } from "react-router-dom";
import { Tiles } from "@/components/motion/Tiles";
import { ArrowRight } from "lucide-react";
import { FLEET } from "@/data/fleet";
import { VehicleCard } from "@/components/fleet/VehicleCard";
import { Item, Lines, Reveal, Stagger } from "@/components/motion/Reveal";

const PICKS = [
  "piattaforma-oil-steel-snake-2413-daily",
  "escavatore-wacker-neuson-ez26",
  "scissor-genie-gs-2646",
  "piattaforma-oil-steel-189-isuzu",
];

export const FleetPreview = () => {
  const picks = PICKS.map((s) => FLEET.find((v) => v.slug === s));
  return (
    <section className="relative overflow-hidden bg-paper py-24 sm:py-32 blueprint-light" data-testid="fleet-preview-section">
      <div className="container-x">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal y={10}><p className="eyebrow flex items-center gap-3"><Tiles />I più richiesti</p></Reveal>
            <Lines as="h2" lines={["Pronti a partire", "per il tuo cantiere."]} className="display mt-4 text-4xl text-ink sm:text-5xl lg:text-6xl" />
          </div>
          <Reveal delay={0.2}>
            <Link to="/parco-mezzi" className="btn-outline" data-testid="fleet-preview-all">
              Tutto il parco mezzi <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" gap={0.1}>
          {picks.map((v) => (
            <Item key={v.slug}>
              <VehicleCard vehicle={v} />
            </Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
